module.exports = __webpack_public_path__ + "media/icons/wspolwlasciciel_green-6027836d.svg";